import { render, staticRenderFns } from "./PurchaseVendorModal.vue?vue&type=template&id=3270e2b6&"
import script from "./PurchaseVendorModal.vue?vue&type=script&lang=ts&"
export * from "./PurchaseVendorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports